import * as React from 'react'
import { SkeletonBar } from 'uiComponents/skeleton/skeleton'
import { TakesUpState } from 'capacity/domain/takesUp'
import { useTranslation } from 'translations'

interface TakesUpCapacityCellProps {
    takesUp: TakesUpState
    isBundle: boolean
}

export function TakesUpCapacityCell({ takesUp, isBundle }: TakesUpCapacityCellProps) {
    const { t } = useTranslation()
    if (isBundle) {
        return <span>{t('capacity.products.takesUp.bundle')}</span>
    }
    if (!takesUp) {
        return <span className="capacity-muted">—</span>
    }
    if (takesUp === 'pending') {
        return <SkeletonBar width="8rem" height="0.9rem" />
    }
    if (takesUp === 'unavailable') {
        return <span className="capacity-muted">{t('capacity.products.takesUp.unavailable')}</span>
    }
    return <span>{t(`capacity.products.takesUp.${takesUp.kind}`)}</span>
}
